import { render, staticRenderFns } from "./assignment.vue?vue&type=template&id=404950b7&scoped=true"
import script from "./assignment.vue?vue&type=script&lang=js"
export * from "./assignment.vue?vue&type=script&lang=js"
import style0 from "./assignment.vue?vue&type=style&index=0&id=404950b7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404950b7",
  null
  
)

export default component.exports